const pageData = [
  {
    order: 1,
    title: "Flexibel",
    heading: "Flexibel",
    subheading:
      "Ordet flexibel användes i över 9000 annonser i Platsbanken (7 juni 2018).",
    dl1: "Flexibel är ett otydligt begrepp för många som söker jobb.",
    dl2:
      "Flexibel används ofta i annonser för både psykolog och svetsare. Men söker man verkligen samma kompetens?",
    navTitle: "Ta reda på hur du kan finslipa dina uttryck!",
    link: "/flexibel/"
  },
  {
    order: 2,
    title: "Quiz",
    heading: "Flexibel",
    subheading:
      "På en arbetsmarknad som snabbt förändras är det eftertraktat att vara flexibel.",
    link: "/flexibel/02/",
    quizHeading: "Vad gör en flexibel kollega enligt dig?",
    quizAnswer1: {
      content: "Bemöter andra utifrån deras behov",
      note: "Relationskompetens"
    },
    quizAnswer2: {
      content: "Hanterar flera arbetsuppgifter eller information parallellt",
      note: "Prioriteringskompetens"
    },
    quizAnswer3: {
      content: "Ändrar arbetssätt och förhållningssätt när det krävs",
      note: "Anpassningskompetens"
    },
    quizAnswer4: {
      content: "Söker och vågar prova okonventionella perspektiv och idéer",
      note: "Utvecklingskompetens"
    },
    modal: {
      heading: "Flexibel",
      subheading: "Grattis!",
      body:
        "Nu kan du vara ännu tydligare med vad du efterfrågar. Gå vidare och ser hur du undviker fler floskler!",
      buttonText: "Fortsätt jakten!"
    }
  }
];

export default pageData;



// WEBPACK FOOTER //
// ./src/data/flexibel.js